module.exports = __webpack_public_path__ + "img/ma.b6dff074.svg";